export function Marquee({ children, reverse = false, duration = 34, className = "" }) {
  const items = <div className="flex items-center shrink-0">{children}</div>;
  return (
    <div className={`marquee ${className}`}>
      <div className={`marquee-track ${reverse ? "rev" : ""}`} style={{ "--dur": `${duration}s` }}>
        {items}
        {items}
      </div>
    </div>
  );
}
